import { Brain } from "lucide-react";

export function DataScienceIcon({ className }: { className?: string }) {
  return <Brain className={className} strokeWidth={1.5} />;
}
